export const currencyLocaleMap = {
  // English variants
  'en-US': 'USD',
  'en-GB': 'GBP',
  'en-AU': 'AUD',
  'en-CA': 'CAD',
  'en-NZ': 'NZD',
  'en-ZA': 'ZAR',
  'en-IE': 'EUR',
  'en-SG': 'SGD',
  'en-HK': 'HKD',
  'en-IN': 'INR',

  // European languages
  'de-DE': 'EUR',
  'de-AT': 'EUR',
  'de-CH': 'CHF',
  'fr-FR': 'EUR',
  'fr-CA': 'CAD',
  'fr-CH': 'CHF',
  'fr-BE': 'EUR',
  'it-IT': 'EUR',
  'it-CH': 'CHF',
  'es-ES': 'EUR',
  'es-MX': 'MXN',
  'es-AR': 'ARS',
  'es-CO': 'COP',
  'es-CL': 'CLP',
  'es-PE': 'PEN',
  'pt-BR': 'BRL',
  'pt-PT': 'EUR',
  'nl-NL': 'EUR',
  'nl-BE': 'EUR',
  'sv-SE': 'SEK',
  'da-DK': 'DKK',
  'nb-NO': 'NOK',
  'fi-FI': 'EUR',
  'pl-PL': 'PLN',
  'cs-CZ': 'CZK',
  'sk-SK': 'EUR',
  'hu-HU': 'HUF',
  'ro-RO': 'RON',
  'bg-BG': 'BGN',
  'hr-HR': 'HRK',
  'sl-SI': 'EUR',
  'et-EE': 'EUR',
  'lv-LV': 'EUR',
  'lt-LT': 'EUR',
  'ru-RU': 'RUB',
  'uk-UA': 'UAH',
  'el-GR': 'EUR',
  'tr-TR': 'TRY',

  // Asian languages
  'ja-JP': 'JPY',
  'ko-KR': 'KRW',
  'zh-CN': 'CNY',
  'zh-TW': 'TWD',
  'zh-HK': 'HKD',
  'zh-SG': 'SGD',
  'hi-IN': 'INR',
  'bn-BD': 'BDT',
  'th-TH': 'THB',
  'vi-VN': 'VND',
  'id-ID': 'IDR',
  'ms-MY': 'MYR',
  'tl-PH': 'PHP',
  'ur-PK': 'PKR',
  'fa-IR': 'IRR',
  'ar-SA': 'SAR',
  'ar-AE': 'AED',
  'ar-EG': 'EGP',
  'ar-JO': 'JOD',
  'ar-LB': 'LBP',
  'ar-KW': 'KWD',
  'ar-QA': 'QAR',
  'ar-BH': 'BHD',
  'ar-OM': 'OMR',
  'he-IL': 'ILS',

  // African languages
  'af-ZA': 'ZAR',
  'sw-KE': 'KES',
  'am-ET': 'ETB',
  'ha-NG': 'NGN',
  'yo-NG': 'NGN',
  'ig-NG': 'NGN',
  'fr-MA': 'MAD',
  'ar-DZ': 'DZD',
  'ar-TN': 'TND',
  'ar-LY': 'LYD',
  'ar-MA': 'MAD',

  // Other major currencies
  'is-IS': 'ISK',
  'mt-MT': 'EUR',
  'ga-IE': 'EUR',
  'cy-GB': 'GBP',
  'eu-ES': 'EUR',
  'ca-ES': 'EUR',
  'gl-ES': 'EUR',
  'mk-MK': 'MKD',
  'sq-AL': 'ALL',
  'sr-RS': 'RSD',
  'bs-BA': 'BAM',
  'me-ME': 'EUR',
};
